import { PosterGenerator } from "@tree-company/poster-generator";
import roobertsRegular from "./assets/fonts/RoobertVRT-Regular.woff2?url";
import roobertsBold from "./assets/fonts/RoobertVRT-Bold.woff2?url";
import roobertsHeavy from "./assets/fonts/RoobertVRT-Heavy.woff2?url";

const fonts = [
  { url: roobertsRegular, style: "normal", weight: 400 },
  { url: roobertsBold, style: "normal", weight: 700 },
  { url: roobertsHeavy, style: "normal", weight: 900 },
];

const generator = new PosterGenerator("/posters", "posts production", {
  fontFamilies: [{ name: "Roobert VRT", fonts }],
});

export default generator;
